// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p-select.ng-dirty.ng-invalid>.p-select {
    border-color:black !important;
}

:host ::ng-deep .p-select-options {
    padding: 0;
}

/* PrimeNG 21 equivalents of the legacy dropdown styling. */
.flagdropdown.p-select {
    width: 90% !important;
    height: 31px !important;
    margin-left: 5px !important;
    border: 1px solid #333 !important;
    border-radius: 0 !important;
    color: #555 !important;
    background: #fff !important;
    background-clip: padding-box !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
}

.flagdropdown.p-select .p-select-label {
    min-height: 29px !important;
    padding: 5px 7px !important;
    color: #555 !important;
    background: #fff !important;
}

.p-select-overlay {
    background: #555 !important;
    border: 1px solid #ccc !important;
    border-radius: 0 !important;
    color: #fff !important;
}

.p-select-overlay .p-select-list {
    padding: 0 !important;
}

.p-select-overlay .p-select-option {
    min-height: 31px !important;
    padding: 3px 7px !important;
    background: #555 !important;
    color: #fff !important;
}

.p-select-overlay .p-select-option .p-select-option-label {
    color: #fff !important;
}

.p-select-overlay .p-select-option.p-focus,
.p-select-overlay .p-select-option.p-select-option-selected {
    background: #444 !important;
    color: #fff !important;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
